<template>
  <v-container>
    <v-row align="center" justify="center">
      <!-- <v-card class="pa-4 ma-4 text-center"> -->
      <!-- <v-row align="center" justify="center"> -->
      <v-col cols="12">
        <img
          src="../assets/logopoon2.png"
          height="250px"
          width="400px"
          style="text-align: center"
        />
      </v-col>

      <v-col cols="12">
        <span>ชำระเงินสำเร็จ, ขอบคุณที่ใช้บริการ</span>
      </v-col>

      <v-col cols="12">
        <v-btn class="mt-10" @click="doClose()" color="#CF5536" dark
          >กลับสู่ร้านค้า</v-btn
        >
      </v-col>
      <!-- </v-row> -->
      <!-- </v-card> -->
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      orderId: "",
    };
  },
  created() {
    // this.orderId = window.location.search;
    const urlParams = this.$route.query;
    console.log("urlParams", urlParams);
    this.orderId = urlParams.orderId;
    this.callAPI();
    this.doSomething();
  },
  methods: {
    async callAPI() {
      const response = await this.axios.get(
        `https://poonthana-service.spoon.in.th/orders/chrageOmiseCompleted/` +
          this.orderId
      );
      //   await this.doSomething();
      console.log("redirect", response);
    },
    doOpen() {
      window.open("spoon://spoon.in.th");
    },
    doSomething() {
      window.location.href = "spoon://spoon.in.th";
    },
    doClose() {
      window.close();
    },
  },
};
</script>